<div class="button-toggle-group-component"><slot></slot></div>